import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { AuthService } from '../core/auth.service'
import { Observable } from 'rxjs/internal/Observable'
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.auth.getValidToken().then(token => {
    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${token}`
    //     }
    //   });
    // });
    if (!request.url.includes('googleapis') && !request.url.includes('resizeimages')) {
      request = request.clone({
        setHeaders: {
          Accept: 'application/json',
        },
      })
    }
    return next.handle(request)
  }
}
